import { Component, HostListener, ChangeDetectionStrategy } from "@angular/core";
import { S25EditableDateComponent } from "../../s25-editable/s25-editable-date/s25.editable.date.component";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { DatepickerApi } from "../../s25-datepicker/date.picker.api";

@TypeManagerDecorator("s25-ng-table-editable-date")
@Component({
    selector: "s25-ng-table-editable-date",
    template: `
        <div
            (click)="clickInside($event)"
            (keydown.enter)="clickInside($event)"
            [tabindex]="readOnly() ? -1 : 0"
            [attr.role]="readOnly() ? '' : 'button'"
            [attr.aria-label]="'Edit date'"
        >
            @if (!readOnly()) {
                <s25-ng-icon [type]="'edit'" [ariaLabel]="false" />
            }
            @if (!isEditing || readOnly()) {
                <span>{{ val | datePipe: dateFormat }}</span>
            }
            @if (isEditing && !readOnly()) {
                <s25-ng-editable-date
                    [(val)]="val"
                    [readOnly]="readOnly()"
                    [dateFormat]="dateFormat"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [popoverOnBody]="popoverOnBody"
                    [inputId]="inputId"
                    [min]="min"
                    [max]="max"
                    [disabled]="disabled"
                    [allowEmpty]="allowEmpty"
                    [hasCommit]="hasCommit"
                    [hasCancelButton]="hasCancelButton"
                    [hasCommitButton]="hasCommitButton"
                    [alwaysEditing]="alwaysEditing"
                    [cancelButtonText]="cancelButtonText"
                    [commitButtonText]="commitButtonText"
                    [customValidation]="customValidation"
                    [fieldId]="fieldId()"
                    (valChange)="valChange.emit($event)"
                    [hasIcon]="false"
                ></s25-ng-editable-date>
            }
        </div>
    `,
    styles: `
        s25-ng-icon {
            float: right;
        }

        ::ng-deep s25-ng-table-editable-date s25-ng-icon svg {
            height: 1em !important;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TableEditableDateComponent extends S25EditableDateComponent {
    isEditing = false;

    clickInside(event: Event & { component?: TableEditableDateComponent }) {
        event.component = this;
        if (this.readOnly()) return;

        const wasEditing = this.isEditing;
        this.isEditing = true;
        if (wasEditing) return;

        // Datepicker mounts async (prefs); focus once its input exists.
        this.cdRef.detectChanges();
        this.zoneRef.run(() => {
            setTimeout(() => this.focusDateField());
        });
    }

    private focusDateField(remainingAttempts = 40): void {
        if (!this.isEditing) return;

        const input = this.elementRef.nativeElement.querySelector("input") as HTMLInputElement | null;
        if (input) {
            input.focus();
            DatepickerApi.open(this.elementRef.nativeElement);
            return;
        }

        if (remainingAttempts > 0) {
            setTimeout(() => this.focusDateField(remainingAttempts - 1), 25);
        }
    }

    @HostListener("window:click", ["$event"])
    clickOutside(event: Event & { component: TableEditableDateComponent }) {
        if (event.component === this) return; // Only trigger when target is not element
        this.isEditing = false;
    }
}
